module.exports = __webpack_public_path__ + "img/WP2023-Online-Programme.97094e7b.png";